var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "app",
      class: {
        "app--print": _vm.print,
      },
      attrs: { id: "app" },
    },
    [
      _vm.print
        ? [_c("router-view")]
        : [
            _c("app-sidebar", { staticClass: "app__sidebar" }),
            _c("app-notifications"),
            _c(
              "div",
              {
                staticClass: "app__layout",
                class: {
                  "app__layout_sidebar-collapsed": _vm.sidebarCollapsed,
                },
              },
              [_c("router-view")],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }